import parseAddress from './parseAddress';
import getPhotoSphereLoader from './getPhotoSphereLoader';
import DepthLoader from '../../third_party/DepthLoader';
import { FOV, QUALITY_LEVEL } from '../../config';

const depthLoader = new DepthLoader();

export default (panoramaId, onProgress) => new Promise((resolve) => {
  onProgress(0.0);

  const panoramaLoader = getPhotoSphereLoader();

  const panoramaLoaderPromise = new Promise((panoramaResolve) => {
    // Ensure progress is below 100.0 until finished all handling.
    const progress = ({ message }) => onProgress(
        message >= 95.0 ? message - 5.0 : message,
    );

    const load = () => {
      panoramaLoader.removeEventListener('load', load);
      panoramaLoader.removeEventListener('progress', onProgress, false);
      panoramaResolve();
    };

    panoramaLoader.addEventListener('progress', progress, false);
    panoramaLoader.addEventListener('load', load, false);
    panoramaLoader.load(panoramaId, QUALITY_LEVEL, FOV);
  });

  const depthLoaderPromise = new Promise((depthResolve) => {
    depthLoader.onDepthLoad = depthResolve();
  }).then(() => depthLoader.load(panoramaId));

  Promise.all([
    panoramaLoaderPromise,
    depthLoaderPromise,
  ]).then(() => {
    depthLoader.onDepthLoad = undefined;

    const { canvas, links, tiles } = panoramaLoader;
    const { depthInfo } = depthLoader;

    resolve({
      address: parseAddress(depthInfo.Location),
      panoramaId: depthInfo.Location.panoId || panoramaId,

      canvas,
      links,
      tiles,
    });

    onProgress(100.0);
  });
});
